import React from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { leaseDateFormat } from "../../utils/utils";
import "bootstrap";
import apiUrl from "../../apiUrlConstant";
import Accordion from "react-bootstrap/Accordion";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class OtherRentalDetails extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      rentalDetails: this.props.rentalDetails,
      waiverDetails: [],
    };
  }

  componentDidMount() {
    console.log("pop");
    fetch(
      `${apiUrl.apiUrl.url}/create-lease/fetch-discount-rent?id=${this.props.match.params.id}`, {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ waiverDetails: data.rentalDetails }, () => {
          console.log(this.state.waiverDetails);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {Object.keys(this.state.rentalDetails).map(function (key, index) {
              return this.state.rentalDetails[key].length > 0
                ? this.state.rentalDetails[key].map(function (rental, index) {
                    if (
                      rental.rentalLogicValue == 1 ||
                      rental.rentalLogicValue == 2 ||
                      rental.rentalLogicValue == 3 ||
                      rental.rentalLogicValue == 2
                    ) {
                      var rentalUnitData = "";

                      if (typeof rental.unit != "undefined") {
                        rentalUnitData = ` - ` + rental.unit + `-`;
                      }

                      if (rental.rentDueFrequency == "Every Month") {
                        rental.rentDueFrequency =
                          rental.rentDueFrequency + " (Advanced Rent)";
                      }

                      if (rental.rentDueFrequency == "Subsequent Month") {
                        rental.rentDueFrequency =
                          rental.rentDueFrequency + " (Arrears Rent)";
                      }

                      return (
                        <div className="container-fluid p-0">
                          <div className="row prospectAccordion">
                            <div className="col-lg-12 p-0">
                              <Accordion.Item eventKey={index}>
                                <Accordion.Header>
                                  {`Period `}
                                  {` `}
                                  {rental.period}
                                  {` `}
                                  {`-`}
                                  {` `}
                                  {rental.rentalLogicText}
                                  {rentalUnitData}
                                  {` - `}
                                  {`( Period Term - ${
                                    rental.periodTermYY == ""
                                      ? "0 Y"
                                      : rental.periodTermYY
                                  }Y -${
                                    rental.periodTermMM == ""
                                      ? "0 Y"
                                      : rental.periodTermMM
                                  }M -${
                                    rental.periodTermDD == ""
                                      ? "0 Y"
                                      : rental.periodTermDD
                                  }D  )`}
                                  {` - `}
                                  {`From ${leaseDateFormat(rental.fromDate)}`}
                                  {` `}
                                  {`To ${leaseDateFormat(rental.toDate)}`}
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div className="container-fluid">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Period{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.period}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Period Term (YY-MM-DD){" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.periodTermYY == ""
                                                ? "0"
                                                : rental.periodTermYY}
                                              {"-"}
                                              {rental.periodTermMM == ""
                                                ? "0"
                                                : rental.periodTermMM}
                                              {"-"}
                                              {rental.periodTermDD == ""
                                                ? "0"
                                                : rental.periodTermDD}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Rental Logic{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.rentalLogicText}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              From{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {leaseDateFormat(rental.fromDate)}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              To{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {leaseDateFormat(rental.toDate)}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Rent UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.rentalUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      {rental.rentalUom == "Per Seat" && (
                                        <>
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  Seat Count{" "}
                                                  <span className="astrik">
                                                    *
                                                  </span>
                                                </label>
                                                <label className="col-sm-7 col-form-label">
                                                  {rental.seatCount}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  Seat Rate{" "}
                                                  <span className="astrik">
                                                    *
                                                  </span>
                                                </label>
                                                <label className="col-sm-7 col-form-label">
                                                  {rental.seatRate}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  Total Seat Amount{" "}
                                                  <span className="astrik">
                                                    *
                                                  </span>
                                                </label>
                                                <label className="col-sm-7 col-form-label">
                                                  {rental.seatTotalAmount}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              On Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.onArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      {rental.rentalUom != "Per Seat" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Rent Rate{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {rental.rentRate}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Rent Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.rentRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Rent Frequency{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.rentFrequency}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Rent Due Date{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.rentDueDate}
                                              {`-`}
                                              {rental.rentDueType}
                                              {`-`}
                                              {rental.rentDueFrequency}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {rental.rentalLogicText.includes(
                                      "Minus CAM"
                                    ) && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Minus CAM %{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rental.minusCamPercent}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  }, this)
                : [];
            }, this)}
          </Accordion>
        </div>

        {this.props.basic && (
          <div className="row tabForm">
            <div
              className="container-fluid"
              style={{ float: "left", marginTop: "40px" }}
            >
              <div className="row">
                <div
                  className="col-lg-12"
                  style={{ backgroundColor: "#003971" }}
                >
                  <h3
                    style={{
                      fontSize: "18px",
                      textAlign: "center",
                      margin: "0",
                      paddingTop: "0.5rem",
                      paddingBottom: "0.5rem",
                      color: "#fff",
                    }}
                  >
                    Waiver Details
                  </h3>
                </div>
              </div>
            </div>
            <Accordion defaultActiveKey="0">
              {this.state.waiverDetails.map(function (rental, index) {
                if (
                  rental.rentalLogicValue == 1 ||
                  rental.rentalLogicValue == 2
                ) {
                  var rentalUnitData = "";

                  if (typeof rental.unit != "undefined") {
                    rentalUnitData = ` - ` + rental.unit + `-`;
                  }

                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {rental.rentalLogicText.includes(
                                  "Minus CAM"
                                ) && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Minus CAM %{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.minusCamPercent}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 3 ||
                  rental.rentalLogicValue == 4
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutOnArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 5 ||
                  rental.rentalLogicValue == 6
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              {" "}
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 7 ||
                  rental.rentalLogicValue == 8
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple tableSimpleWithNoFlex">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">FROM</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 9 ||
                  rental.rentalLogicValue == 10
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">Product</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                          {name.productName}
                                                        </td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 11 ||
                  rental.rentalLogicValue == 12
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">Product</th>
                                                  <th scope="col">From</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                          {name.productName}
                                                        </td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 13 ||
                  rental.rentalLogicValue == 14 ||
                  rental.rentalLogicValue == 15
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 16 ||
                  rental.rentalLogicValue == 17
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup revenue">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup revenue">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutOnArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup revenue">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup revenue">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 fitoutPopup revenue">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Fitout Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.fitoutFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {rental.rentalLogicText.includes(
                                  "Minus CAM"
                                ) && (
                                  <div className="row">
                                    <div className="col-lg-12 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 18 ||
                  rental.rentalLogicValue == 19
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">FROM</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 20 ||
                  rental.rentalLogicValue == 21
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">Product</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                          {name.productName}
                                                        </td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 22 ||
                  rental.rentalLogicValue == 23
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Applicability{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareApplicability}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-12 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">Product</th>
                                                  <th scope="col">From</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rental.slabs.length > 0 &&
                                                  rental.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                          {name.productName}
                                                        </td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  rental.rentalLogicValue == 24 ||
                  rental.rentalLogicValue == 25 ||
                  rental.rentalLogicValue == 26 ||
                  rental.rentalLogicValue == 27
                ) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {rental.rentalLogicText}
                              {` - `}
                              {`From ${leaseDateFormat(rental.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rental.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term (YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.periodTermYY == ""
                                            ? "0"
                                            : rental.periodTermYY}
                                          {"-"}
                                          {rental.periodTermMM == ""
                                            ? "0"
                                            : rental.periodTermMM}
                                          {"-"}
                                          {rental.periodTermDD == ""
                                            ? "0"
                                            : rental.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rental Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rental.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentalUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.rentDueDate}
                                          {`-`}
                                          {rental.rentDueType}
                                          {`-`}
                                          {rental.rentDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareDueDate}
                                          {`-`}
                                          {rental.revenueShareDueType}
                                          {`-`}
                                          {rental.revenueShareDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 fitoutPopup">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share Reconcilitation{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rental.revenueShareReconcilitation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rental.rentalLogicText.includes(
                                    "Minus CAM"
                                  ) && (
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Minus CAM %{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rental.minusCamPercent}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                }
              }, this)}
            </Accordion>
          </div>
        )}

        <div className="row tabForm">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Notes
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.rentalNotes}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OtherRentalDetails);
